import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const TerminatedService = {
  async getAllRows(mode = "", filters = {}) {
    try {
      const params = { ...filters, ...(mode ? { mode } : {}) };
      const result = await axios.get(`${apiUrl}/Partner/Terminated`, { params });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement des marches resilies ou echus",
      data: [],
    };
  },

  async getPartnerRows(partnerName) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Terminated/detail`, {
        params: { partnerName },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement du detail des marches resilies ou echus",
      data: [],
    };
  },
};

export default TerminatedService;
